export default "__VITE_ASSET__YevYUUP5__"